import { render, staticRenderFns } from "./SidebarModal.vue?vue&type=template&id=1292f942&scoped=true&"
import script from "./SidebarModal.vue?vue&type=script&lang=js&"
export * from "./SidebarModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1292f942",
  null
  
)

export default component.exports